export const normalizeTag = (tag: string) => {
  const withoutWhitespace = tag.replaceAll(/\s/g, "");
  return withoutWhitespace.charAt(0) === "#"
    ? withoutWhitespace.slice(1)
    : withoutWhitespace;
};
